import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import ReCAPTCHA from "react-google-recaptcha";
import '../styles/ccpa.css';

export default function CCPA() {

  const url = process.env.NODE_ENV === 'production' 
  ? "https://emaildrop.com/privacy/requests"
  : "/privacy/requests";
  
  const [data, setData] = useState({
    telephone: "",
    requestType: "",
    email: "",
    state: "",
    ipAddress: ""
  });
  

  function handle(e) {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
    //console.log(newdata);

  }

  const [showHideCorrectionTextArea, setShowHideCorrectionTextArea] =
    useState('');

  const [showTypePersonalInfoOption, setshowTypePersonalInfoOption] =
    useState('');

  const handleShowHide = e => {
    const getRequestType = e.target.value;
    // console.log(getRequestType);
    setShowHideCorrectionTextArea(getRequestType);
    setshowTypePersonalInfoOption(getRequestType);
  };

  // const key = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"; // test key - commented out
  const key = "6LfEU7klAAAAAN2sgKPA9lIMdWG5LiiLmL8A8oRh"; // Actual site key


  const [captchaIsDone, setCaptchaDone] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [stateName, setStateName] = useState('');
  const [telephoneNumber, settelephoneNumber] = useState('');
  // const [isEmailValid, setIsEmailValid] = useState(true);
  const [emailAddress, setemailAddress] = useState('');
  const [correctionService, setCorrectionService] = useState('');
  const [error, setError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [completionForm, setCompletion] = useState(false);
  const [optInMessage, setOptInMessage] = useState('');
  const [checkState, setStateError] = useState(false);
  const [checkPhoneNumber, setPhoneNumberError] = useState(false);

  // Function to fetch and log IP address
  const fetchIpAddress = async () => {
    try {
      const response = await Axios.get('https://api.ipify.org?format=json');
      const ipAddress = response.data.ip;
      //console.log("User's IP Address:", ipAddress);
      setData(prevData => ({ ...prevData, ipAddress }));
    } catch (error) {
      console.error("Error fetching the IP address", error);
    }
  };
  

  useEffect(() => {
    fetchIpAddress();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
  
    if (
      showTypePersonalInfoOption === "delete" ||
      showTypePersonalInfoOption === "sell" ||
      showTypePersonalInfoOption === "info" ||
      showTypePersonalInfoOption === "limit" ||
      showTypePersonalInfoOption === "opt-in"
    ) {
      if (showTypePersonalInfoOption === "opt-in") {
        setOptInMessage("Your email has been opted back in!");
  
        Axios.post(url, {
          telephone: data.telephone,
          requestType: data.requestType,
          email: data.email,
          first_name: firstName,
          last_name: lastName,
          state: stateName,
          correctionService: correctionService,
          info_type: data.infoType,
          ipAddress: data.ipAddress
        }, {
          headers: {
            'x-api-key': process.env.REACT_APP_FORM_API_KEY,
            'Content-Type': 'application/json',
          }
        })
        .then(res => {
          console.log(res.data);
        });
  
        setCompletion(true);
        return;
      }
  
      if (firstName.length === 0 || lastName.length === 0 || telephoneNumber.length === 0 || emailAddress.length === 0) {
        setError(true);
      } else if (telephoneNumber.length !== 10) {
        setPhoneNumberError(true);
        setStateError(false);
        setCompletion(false);
      } else if (firstName.length !== 0 && lastName.length !== 0 && telephoneNumber.length === 10 && emailAddress.length !== 0 && stateName !== " " && correctionService.length === 0) {
        if (stateName === "CA" || stateName === "CO" || stateName === "CT" || stateName === "DE" || stateName === "IN" || stateName === "IA" || stateName === "KY" || stateName === "MD" || stateName === "MT" || stateName === "NE" || stateName === "NH" || stateName === "NJ" || stateName === "OR" || stateName === "RI" || stateName === "TN" || stateName === "TX" || stateName === "UT" || stateName === "VA") {
          setCompletion(true);
          setStateError(false);
  
          Axios.post(url, {
            telephone: data.telephone,
            requestType: data.requestType,
            email: data.email,
            first_name: firstName,
            last_name: lastName,
            state: stateName,
            correctionService: correctionService,
            info_type: data.infoType,
            ipAddress: data.ipAddress
          }, {
            headers: {
              'x-api-key': process.env.REACT_APP_FORM_API_KEY,
              'Content-Type': 'application/json',
            }
          })
          .then(res => {
            console.log(res.data);
          });
  
        } else {
          setStateError(true);
          setCompletion(false);
        }
      } else {
        setCompletion(true);
        Axios.post(url, {
          telephone: data.telephone,
          requestType: data.requestType,
          email: data.email,
          first_name: firstName,
          last_name: lastName,
          state: stateName,
          correctionService: correctionService,
          info_type: data.infoType,
          ipAddress: data.ipAddress
        }, {
          headers: {
            'x-api-key': process.env.REACT_APP_FORM_API_KEY,
            'Content-Type': 'application/json',
          }
        })
        .then(res => {
          console.log(res.data);
        });
      }
    } else if (showTypePersonalInfoOption === "correct" || showTypePersonalInfoOption === "appeal") {
      if (firstName.length === 0 || lastName.length === 0 || telephoneNumber.length === 0 || emailAddress.length === 0) {
        setError(true);
      } else if (telephoneNumber.length !== 10) {
        setPhoneNumberError(true);
        setStateError(false);
        setCompletion(false);
      } else if (firstName.length !== 0 && lastName.length !== 0 && telephoneNumber.length === 10 && emailAddress.length !== 0 && stateName !== " " && correctionService.length === 0) {
        setDescriptionError(true);
        setCompletion(false);
      } else if (stateName === "CA" || stateName === "CO" || stateName === "CT" || stateName === "DE" || stateName === "IN" || stateName === "IA" || stateName === "KY" || stateName === "MD" || stateName === "MT" || stateName === "NE" || stateName === "NH" || stateName === "NJ" || stateName === "OR" || stateName === "RI" || stateName === "TN" || stateName === "TX" || stateName === "UT" || stateName === "VA") {
        setStateError(false);
        setCompletion(true);
  
        Axios.post(url, {
          telephone: data.telephone,
          requestType: data.requestType,
          email: data.email,
          first_name: firstName,
          last_name: lastName,
          state: stateName,
          correctionService: correctionService,
          info_type: data.infoType,
          ipAddress: data.ipAddress
        }, {
          headers: {
            'x-api-key': process.env.REACT_APP_FORM_API_KEY,
            'Content-Type': 'application/json',
          }
        })
        .then(res => {
          console.log(res.data);
        });
      } else {
        setStateError(true);
        setCompletion(false);
      }
    }
  };

  function onCaptcha() {
    setCaptchaDone(true);
  }
  return (

    <Container className="App-container">
      <div role="main" className="container p-5">
        <script src="https://www.google.com/recaptcha/api.js"></script>
        <meta charSet="utf-8" />
        <Helmet>
          <title>CCPA Request Form</title>
        </Helmet>

        <h1>Consumer Privacy Choices</h1>
        <p>Residents of California, Colorado, Connecticut, Delaware, Indiana, Iowa, Kentucky, Maryland, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, or Virginia have additional rights to access and control Personal Information Qualfon has about them. Several exceptions may apply.</p>
        <p>
        Residents of California, Colorado, Connecticut, Delaware, Indiana, Iowa, Kentucky, Maryland, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, or Virginia may submit consumer requests by completing the form below or calling us at (405) 740-3210. We will process verified requests to know, delete, or correct Personal Information within 45 days, subject to any applicable exceptions and extensions permitted by law. We will process requests to opt-out of the sale or sharing of Personal Information or to limit use of Sensitive Personal Information within 15 business days. We will process rights to appeal requests within the timeframe established by your state’s privacy law, but generally within 45 days of receipt.
        </p>
        <p>
          If you are an authorized agent submitting a request for another California resident, you must provide a written authorization from the Consumer (along with proof of your identity) or a copy of a lawful power or attorney. You may provide this documentation via email at <a href="mailto:consumerprivacy@qualfon.com">consumerprivacy@qualfon.com</a> after submitting the request. We may contact you or the Consumer on whose behalf you claim to act to verify your authorization. </p>

        <p>
          Additional information about how we use and disclose Personal Information, can be found in our <a href="https://nam04.safelinks.protection.outlook.com/?url=https%3A%2F%2Fqualfon.com%2Fprivacy-policy%2F&data=05%7C01%7Ckate.crispignani%40qualfon.com%7Cbd6313e1cc65417dc0a208daddea7360%7C5e3f0773dc5d4e4083d6f2e42e50db50%7C0%7C0%7C638066296291663141%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=43Dia4%2F5gscX7syrqklx%2FNx0tFh5DPBXlXGfKz6Ja%2Fg%3D&reserved=0" target="_blank" rel="noreferrer">Privacy Policy</a>. Before submitting your consumer request, we urge you to read and consider the Privacy Policy.</p>

        <hr />


        {/* {!isEmailValid && firstName.length !== 0 && lastName.length !== 0 && telephoneNumber.length !== 10 && emailAddress.length !== 0 && <p>Please enter a valid email.</p>} */}
        {checkPhoneNumber && firstName.length !== 0 && lastName.length !== 0 && telephoneNumber.length !== 10 && emailAddress.length !== 0 ? <div className="alert alert-danger">Your phone number is incorrect! Please enter the correct number!</div> : ""}
        {error && firstName.length <= 0 && lastName.length <= 0 && telephoneNumber.length <= 0 && emailAddress.length <= 0 ? <div className="alert alert-danger">All fields are required in order for us to search our records.</div> : ""}
        {descriptionError && correctionService.length <= 0 && firstName.length !== 0 && lastName.length !== 0 && telephoneNumber.length !== 0 && emailAddress.length !== 0 ? <div className="alert alert-danger">Description required in order for us to correctly handle your request.</div> : ""}
        {checkState && firstName.length !== 0 && lastName.length !== 0 && telephoneNumber.length !== 0 && emailAddress.length !== 0 ? <div className="alert alert-danger">Your state selection is incorrect! Please choose the correct state!</div> : ""}
        <h2>Privacy Request</h2>
        <p>
          Please provide the following fields. The information which you provide
          will be used to verify your request and to attempt to identify you
          within our data records.
        </p>
        <h1 style={{ textAlign: 'center', fontSize: '30px', fontWeight: 'bold', padding: '30px' }} >For California, Colorado, Connecticut, Delaware, Indiana, Iowa, Kentucky, Maryland, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Rhode Island, Tennessee, Texas, Utah, or Virginia Residents only</h1>

        <Form className="data-entry-form" onSubmit={handleSubmit} >
          <Form.Group className="ccpa-form-group mb-3" controlId="requestType" value={data.requestType} onChange={(e) => handle(e)}>
            <Form.Label className="fw-bold">Request Type:</Form.Label>
            <Form.Select
              className="ccpa-form-select"
              onChange={e => handleShowHide(e)}
              required
            >
              <option value="default" disabled selected>---- Select a Request Type ----</option>
              <option value="limit">Limit Use of Sensitive Personal Information</option>
              <option value="delete">Right to Delete</option>
              <option value="correct">Right to Correct</option>
              <option value="sell">Do Not Sell or Share</option>
              <option value="info">Right To Know</option>
              <option value="appeal">Right To Appeal</option>
              <option value="opt-in">Opt Back In</option>
            </Form.Select>
          </Form.Group>

          {showTypePersonalInfoOption === 'info' && (
            <Form.Group className="ccpa-form-group mb-3" controlId="infoType" value={data.infoType} onChange={(e) => handle(e)}>
              <Form.Label className="fw-bold" >
                What type of personal information would you like to receive?
              </Form.Label>
              <Form.Select
                className="ccpa-form-select"

                // onChange={e => handleShowHide(e)}

                required
              >
                <option value="categories" selected>
                  The categories of Personal Information you have on file about
                  me
                </option>

                <option value="onfile">
                  The specific pieces of my Personal Information you have on
                  file
                </option>
              </Form.Select>

            </Form.Group>
          )}

          <Form.Group className="ccpa-form-group mb-3" controlId="firstName" value={data.first_name} onChange={(e) => handle(e)}>
            <Form.Label className="fw-bold">First Name:</Form.Label>
            <Form.Control onChange={event => setFirstName(event.target.value)} type="text" />
          </Form.Group>

          <Form.Group className="ccpa-form-group mb-3" controlId="lastName" value={data.last_name} onChange={(e) => handle(e)}>
            <Form.Label className="fw-bold">Last Name:</Form.Label>
            <Form.Control onChange={event => setLastName(event.target.value)} type="text" />
          </Form.Group>

          <Form.Group className="ccpa-form-group mb-3" controlId="telephone" value={data.telephone} onChange={(e) => handle(e)}>
            <Form.Label className="fw-bold">Telephone:</Form.Label>
            <Form.Control onChange={event => settelephoneNumber(event.target.value)} type="text" />
          </Form.Group>

          <Form.Group className="ccpa-form-group mb-3" controlId="state" value={data.state_name} onChange={(e) => handle(e)}>
            <Form.Label className="fw-bold">State:</Form.Label>

            <Form.Select className="ccpa-form-select" onChange={event => setStateName(event.target.value)} required>
              <option value="first-option" disabled selected>--- Select a State ---</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="ccpa-form-group mb-3" controlId="email" value={data.email} onChange={(e) => handle(e)}>
            <Form.Label className="fw-bold">Email:</Form.Label>
            <Form.Control onChange={event => setemailAddress(event.target.value)} type="email" />
          </Form.Group>

          {showHideCorrectionTextArea === 'correct' && (
            <Form.Group className="ccpa-form-group mb-3" controlId="correctionTextArea" value={data.correction_text} onChange={(e) => handle(e)}>
              <Form.Label className="fw-bold">Correction or Service Needed:</Form.Label>
              <Form.Control onChange={event => setCorrectionService(event.target.value)} type="correctionTextArea" as="textarea" name="message" />
            </Form.Group>
          )}

          {showHideCorrectionTextArea === 'appeal' && (
            <Form.Group
              className="ccpa-form-group mb-3"
              controlId="correctionTextArea"
              value={data.correction_text}
              onChange={(e) => handle(e)}
            >
              <Form.Label className="fw-bold">
                Correction or Service Needed:
              </Form.Label>
              <Form.Control onChange={event => setCorrectionService(event.target.value)} type="correctionTextArea" as="textarea" name="message" />
            </Form.Group>
          )}
          <Form.Group>
            {captchaIsDone && <button disabled={completionForm} id="thebutton" className="btn btn-primary custom-margin-2 float-left mt-2">Submit</button>}
          </Form.Group>


        </Form>
        <ReCAPTCHA style={{ padding: '10px' }}
          sitekey={key}
          onChange={onCaptcha}
        />
         {completionForm && <div className="alert alert-success">{optInMessage || "Congratulations! Your requests have been recorded! Please wait patiently until you hear back from us!"}</div>}
      </div>
    </Container>
  );
}
